import { CampaignTriggersUnion, CampaignTypeUnion } from "types/campaigns";
import { Condition, SegmentFECondition } from "./conditions";

export enum SegmentTypes {
  STATIC = "static",
  DYNAMIC = "dynamic",
}

export type SegmentTypesUnion = `${SegmentTypes}`;

export type Parts = {
  criteria: Condition[];
};

export interface SegmentBEFields {
  active: boolean;
  description?: string;
  name: string;
  parts: Parts[];
}

export type SegmentData = {
  active: boolean;
  averageClv: number;
  averageTransactionAmount: number;
  averageTransactions: number;
  calculatedAt: string;
  createdAt: string;
  currency: string;
  customersCount: number;
  description: string;
  name: string;
  parts: Parts[];
  segmentId: string;
};

export type SegmentFEData = Omit<SegmentData, "parts"> & {
  type: SegmentTypesUnion;
  parts: SegmentFEParts[];
};

export type SegmentFEParts = {
  criteria: SegmentFECondition[];
};

export type SegmentFEFields = Omit<SegmentBEFields, "parts"> & {
  type: SegmentTypesUnion;
  parts: SegmentFEParts[];
};

export type SegmentDataResponse<T extends string | string[]> = T extends string
  ? SegmentData
  : SegmentData[];

export type SegmentMemberItem = {
  birthDate?: string | Date;
  createdAt?: string | Date;
  customerId: string;
  email: string;
  firstName: string;
  gender: string;
  lastName: string;
  phone: string;
};

export type SegmentType = {
  segment: SegmentTypesUnion;
  descriptionText: string;
  label: string;
};

export type AssociatedItem = {
  id: string;
  active: boolean;
  name: string;
  additionalData?: {
    campaign_type: CampaignTypeUnion;
    campaign_trigger: CampaignTriggersUnion;
  };
};

export enum AssociatedItemType {
  CAMPAIGN = "campaign",
  REWARD = "reward",
  ACHIEVEMENT = "achievement",
}

export type AssociatedItemTypeUnion = `${AssociatedItemType}`;
